import React from 'react';

import { Link } from '@ergeon/core-components';

import { FooterTermsProps } from './types';

const FooterTerms: React.FC<FooterTermsProps> = ({ ergeonUrl }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="flex md:flex-row flex-col md:justify-between md:items-center gap-4 pt-8 border-gray-200 border-t">
      <p className="text-gray-500 paragraph-3">
        &copy; {currentYear} Ergeon Inc. All rights reserved.
      </p>
      <div className="flex items-center gap-4">
        <Link className="paragraph-3" href={`${ergeonUrl}/terms`}>
          Terms of Service
        </Link>
        <Link className="paragraph-3" href={`${ergeonUrl}/privacy`}>
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default FooterTerms;
